import {LogLevel} from '@azure/msal-browser';

export const environment = {
  production: true,
  staging: false,
  development: false,
  hmr: false,
  azureClientID: '7edca6b8-ec29-4f44-b823-1868c0a5cc90',
  apiURL: 'https://rest.torchbi.com/api',
  filesAPIURL: 'https://files.torchbi.com/api',
  redirectUri: 'https://torchbi.com/authenticated',
  postLogoutRedirectUri: 'https://torchbi.com/login',
  tinyAPIKey: 'xm4kkkgj1aoyy4rmh2ljje3cl3ypebfexfyza1vqzmsjg4tc',
  torchAPIKey: 'BXDP2AJ-AZ7M9GB-MRFF2V1-0GDSX85',
  filesWS: 'https://files.torchbi.com',
  appInsights: {
    instrumentationKey: '8a6ab03b-8cc7-4315-ad60-57cb38a3d668'
  },
  enableServiceWorker: true,
  pwaName: 'TORCH',
  emitLogs: false,
  msal: {
    logLevel: LogLevel.Error,
    piiLogging: false,
  },
  maxDiscrepancyQueryExport: 10000,
  maxRemovalQueryExport: 10000,
  maxWeightBalanceQueryExport: 40000,
};
